<app-text-input
  [name]="name"
  [control]="number"
  [errors]="errors"
  inputmode="numeric"
  type="number"
  >
  <app-select-input
    class="auth-max-age-unit"
    [control]="unit"
    [values]="timeUnits"
    placeholder="Time unit"
    [validation]="false"
    >
  </app-select-input>
</app-text-input>

@if (showWarning) {
  <div class="banner banner-warning">
    Max Sign-on Session over 24 hours is not recommended.
  </div>
}
